module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAiCAYAAABMfblJAAAAAXNSR0IArs4c6QAAALZJREFUSA3t11EKgCAMBuDsEuFps9NGpygnIVip23I+yAQfrPSzn1hlpko79v2sXJKcXqw1yYHHYH6MxYcKNo9YI9VIyQmM/9AYXyudz2UlZ8ObsIVC2wndfGF3sbILowGDUCIIAyE0Yi9QAE2wT7Ah+sKyYAP0EyuCP9AsVgUZaBFDgQS0iqFBBIrCSGABRWOwBrlBcfD9vLsjL8CZcKN9MM4GdY5oAvDGJ/0d/d3N+B9R3e/wAqZ5V2AOtfl1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/img/download.png
// module id = 344
// module chunks = 0